import { styled } from '@mui/material';

const PREFIX = 'CompGroupRowHeader';
const ICON_HEIGHT = 24; // Define the icon height constant

export const compGroupRowHeaderClasses = {
  fullCell: `${PREFIX}-fullCell`,
  contentValue: `${PREFIX}-contentValue`,
  iconContainer: `${PREFIX}-iconContainer`,
  icon: `${PREFIX}-icon`,
  warningText: `${PREFIX}-warningText`,
  textContainer: `${PREFIX}-textContainer`,
};

export const CompGroupRowHeaderRoot = styled('div')(({ theme }) => ({
  [`& .${compGroupRowHeaderClasses.fullCell}`]: {
    height: '28px',
  },

  [`& .${compGroupRowHeaderClasses.contentValue}`]: {
    display: 'flex',
    textAlign: 'start',
  },

  [`& .${compGroupRowHeaderClasses.iconContainer}`]: {
    background: `linear-gradient(90deg, #ffffffe6 0%, ${theme.palette.common.white} 50%)`,
    display: 'flex',
    opacity: 0,
    paddingLeft: theme.spacing(2.5),
    position: 'absolute',
    right: '-100%',
    top: `calc(50% - (${ICON_HEIGHT}px / 2))`,
    transition: 'ease all 0.25s',
    '&.active': {
      opacity: 1,
      right: 5,
    },
  },

  [`& .${compGroupRowHeaderClasses.icon}`]: {
    cursor: 'pointer',
  },

  [`& .${compGroupRowHeaderClasses.warningText}`]: {
    color: theme.palette.warning.main,
  },

  [`& .${compGroupRowHeaderClasses.textContainer}`]: {
    display: 'flex',
    flexWrap: 'nowrap',
  },
}));
